import Vue from "vue";
import VueRouter from "vue-router";

//A-Z
import About from "@/module/Static/page/About.vue";
import Campaign from "@/module/Detail/page/Campaign.vue";
import Category from "@/module/List/page/Category.vue";
import ChangePass from "@/module/Profile/page/ChangePass.vue";
import Contact from "@/module/Static/page/Contact.vue";
import History from "@/module/History/page/History.vue";
import Welcome from "@/module/Welcome/page/Welcome.vue";
import ErrorPage from "@/module/ErrorPage/page/ErrorPage.vue";
import Home from "@/module/Home/page/Home.vue";
import HomeLogin from "@/module/Home/page/HomeLogin.vue";
import Privilege from "@/module/List/page/Privilege.vue";
import PrivilegeLuckydraw from "@/module/List/page/PrivilegeLuckydraw.vue";
import Register from "@/module/Register/page/Register.vue";
import Pdpa from "@/module/Pdpapage/page/Pdpa.vue";
import PdpaTheme from "@/module/Pdpapage/page/PdpaTheme.vue";

import Voucher from "@/module/Voucher/page/Voucher.vue";
// import Terms from "@/module/Static/page/Terms.vue";
// import Consent from "@/module/Static/page/Consent.vue";
import PromiseAllExample from "@/module/Example/page/PromiseAllExample.vue";
import PromiseChainExample from "@/module/Example/page/PromiseChainExample.vue";
import AsyncAwaitExample from "@/module/Example/page/AsyncAwaitExample.vue";
import LineLogin from "@/module/LineLogin/page/LineLogin.vue";
import Address from "@/module/Address/DeliveryAddress/page/Address.vue";
import TaxAddress from "@/module/Address/TaxAddress/page/TaxAddress.vue";
import ObserveMainPage from "@/module/Example/observe/MainPage.vue";
import KeepAliveMain from "@/module/Example/KeepAlive/PageMain.vue";
import KeepAlivePageList from "@/module/Example/KeepAlive/PageList.vue";
import KeepAlivePageDetail from "@/module/Example/KeepAlive/PageDetail.vue";
import News from "@/module/Detail/page/News.vue";
import Sso from "@/module/SsoAuth/Home.vue";
import OtpSso from "@/module/SsoAuth/Otp.vue";
import VuexStoreMain from "@/module/Example/VuexStore/VuexStoreMain.vue";
import ElemTracking from "@/module/Example/ElementTracking/ElemTracking.vue";
import Interceptor from "@/module/Example/Interceptor/Interceptor.vue";
import Reconsent from "@/module/Reconsent/page/Reconsent.vue";
// import TransitionPageMain from "@/module/Example/Transition/TransitionPageMain.vue";
// import TransitionPage from "@/module/Example/Transition/TransitionPage.vue";
// import TransitionPageTwo from "@/module/Example/Transition/TransitionPageTwo.vue";

import NewPrivilege from "@/module/Privilege/page/Privilege.vue";
import TestProfile from "@/module/Home/page/TestProfile.vue";

import Default from "@/module/Home/page/Default.vue";
import Notfound from "@/module/Static/page/NotFound.vue";

/// New Page
import Profile from "@/module/Profile/page/Profile.vue";
import EditProfile from "@/module/Profile/page/EditProfile.vue";
import ChangeTel from "@/module/Profile/page/ChangeTel.vue";
import OTPChangeTel from "@/module/Profile/page/OTPChangeTel.vue";
import HistoryEarnPoint from "@/module/History/page/HistoryEarnPoint.vue";
import HistoryBurnPoint from "@/module/History/page/HistoryBurnPoint.vue";
import Menu from "@/module/Menu/page/Menu.vue";
import MenuDetail from "@/module/Menu/page/MenuDetail.vue";
import CafeMap from "@/module/Menu/page/CafeMap.vue";
import Order from "@/module/Order/page/Order.vue";
import ChangePlan from "@/module/Order/page/ChangePlan.vue";
import EditAddress from "@/module/Address/DeliveryAddress/editAdress.vue";
import MissionBadge from "@/module/Menu/page/MissionBadge.vue";
import MissionCollection from "@/module/Menu/page/MissionCollection.vue";
import PrivacySettings from "@/module/Profile/page/PrivacySettings.vue";
import MktOptionSetting from "@/module/MktOptionSetting/page/MktOptionSetting.vue";
import InactiveUser from "@/module/ActiveUser/page/InactiveUser.vue";
import ActiveUser from "@/module/ActiveUser/page/ActiveUser.vue";
import RequestDocument from "@/module/Profile/page/RequestDocument.vue";
import Benefit from "@/module/Profile/page/Benefit.vue";
import CookiePolicy from "@/module/Profile/page/CookiePolicy.vue";
import AllBeverage from "@/module/Subscription/page/AllBeverage.vue";
import PackageDetail from "@/module/Subscription/page/PackageDetail.vue";
import SubscriptionDetail from "@/module/Subscription/page/SubscriptionDetail.vue";
import SubscriptionForm from "@/module/Subscription/page/SubscriptionForm.vue";
import Maintenance from "@/module/Maintenance/page/Maintenance.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        redirect: "/linelogin"
    },
    {
        path: "/voucher",
        name: "voucher",
        component: Voucher
    },
    {
        path: "/default",
        name: "default",
        component: Default
    },
    {
        path: "/interceptor",
        name: "Interceptor",
        component: Interceptor
    },
    {
        path: "/home",
        name: "home",
        component: Home
    },
    {
        path: "/homelogin",
        name: "homelogin",
        component: HomeLogin
    },
    {
        path: "/welcome",
        name: "welcome",
        component: Welcome
    },
    {
        path: "/ErrorPage",
        name: "ErrorPage",
        component: ErrorPage
    },
    {
        path: "/about",
        name: "about",
        component: About
    },
    {
        path: "/privilege",
        name: "privilege",
        component: Privilege
    },
    {
        path: "/privilegeluckydraw",
        name: "privilegeluckydraw",
        component: PrivilegeLuckydraw
    },
    {
        path: "/newPrivilege",
        name: "newPrivilege",
        component: NewPrivilege
    },
    {
        path: "/campaign/:campaignId",
        name: "campaign",
        component: Campaign,
        props: true
    },
    {
        path: "/history",
        name: "history",
        component: History
    },
    {
        path: "/history/:tab",
        name: "history tab",
        component: History
    },
    {
        path: "/profile",
        name: "profile",
        component: Profile
    },
    {
        path: "/editprofile",
        name: "editprofile",
        component: EditProfile
    },
    {
        path: "/changetel",
        name: "changetel",
        component: ChangeTel
    },
    {
        path: "/otpchangetel",
        name: "otpchangetel",
        component: OTPChangeTel
    },
    {
        path: "/contact",
        name: "contact",
        component: Contact
    },
    {
        path: "/changepass",
        name: "changepass",
        component: ChangePass
    },
    {
        path: "/register",
        name: "register",
        component: Register,
        props: true
    },
    {
        path: "/category",
        name: "category",
        component: Category
    },
    {
        path: "/terms/:tab",
        name: "terms",
        props: true,
        component: Pdpa
    },
    {
        path: "/consent",
        name: "consent",
        component: Pdpa
    },
    {
        path: "/termstheme",
        name: "termstheme",
        component: PdpaTheme
    },
    {
        path: "/consenttheme",
        name: "consenttheme",
        component: PdpaTheme
    },
    {
        path: "/privacysettings",
        name: "privacysettings",
        component: PrivacySettings
    },
    {
        path: "/mktoptionsetting",
        name: "mktOptionSetting",
        component: MktOptionSetting
    },
    {
        path: "/example/promiseall",
        name: "promiseall",
        component: PromiseAllExample
    },
    {
        path: "/example/promisechain",
        name: "promisechain",
        component: PromiseChainExample
    },
    {
        path: "/example/asyncawait",
        name: "asyncawait",
        component: AsyncAwaitExample
    },
    {
        path: "/linelogin",
        name: "linelogin",
        component: LineLogin
    },
    {
        path: "/address/list",
        name: "addresslist",
        component: Address
    },
    {
        path: "/address/tax",
        name: "taxaddress",
        component: TaxAddress
    },
    {
        path: "/observe",
        name: "observe",
        component: ObserveMainPage
    },
    {
        path: "/keepalive",
        name: "keepalive",
        component: KeepAliveMain,
        children: [
            {
                path: "/keepalive",
                name: "keepalive_list",
                component: KeepAlivePageList
            },
            {
                path: "/keepalive/:campaignId",
                name: "keepalive_detail",
                component: KeepAlivePageDetail
            }
        ]
    },
    // {
    //     path: "/transition",
    //     name: "transition",
    //     component: TransitionPageMain,
    //     children: [
    //         {
    //             path: "",
    //             name: "TransitionPage",
    //             component: TransitionPage
    //         },
    //         {
    //             path: "two",
    //             name: "TransitionPageTwo",
    //             component: TransitionPageTwo
    //         }
    //     ]
    // },
    {
        path: "/vuexstore",
        name: "vuexstore",
        component: VuexStoreMain
    },
    {
        path: "/elemtracking",
        name: "elemtracking",
        component: ElemTracking
    },
    {
        path: "/testprofile",
        name: "testprofile",
        component: TestProfile
    },
    {
        path: "/historyearnpoint",
        name: "historyearnpoint",
        component: HistoryEarnPoint
    },
    {
        path: "/historyburnpoint",
        name: "historyburnpoint",
        component: HistoryBurnPoint
    },
    {
        path: "/menu",
        name: "menu",
        component: Menu
    },
    {
        path: "/menudetail",
        name: "menudetail",
        component: MenuDetail,
        props: true
    },
    {
        path: "/maintenance",
        name: "maintenance",
        component: Maintenance
    },
    {
        path: "/cafemap/:targetpage",
        name: "cafemap",
        component: CafeMap
    },
    {
        path: "/order",
        name: "order",
        component: Order
    },
    {
        path: "/changeplan/:date",
        name: "changeplan",
        component: ChangePlan
    },
    {
        path: "/editaddress",
        name: "editaddress",
        component: EditAddress
    },
    {
        path: "/missionbadge",
        name: "missionbadge",
        component: MissionBadge
    },
    {
        path: "/missioncollection",
        name: "missioncollection",
        component: MissionCollection
    },
    {
        path: "/news/:campaignId",
        name: "news",
        component: News
    },
    {
        path: "/sso",
        name: "sso",
        component: Sso
    },
    {
        path: "/inactiveuser",
        name: "inactiveuser",
        component: InactiveUser
    },
    {
        path: "/activeuser",
        name: "activeuser",
        component: ActiveUser
    },
    {
        path: "/requestdocument/:mode",
        name: "requestdocument",
        component: RequestDocument
    },
    {
        path: "/otpsso",
        name: "otpSso",
        component: OtpSso,
        props: true
    },
    {
        path: "/benefit",
        name: "benefit",
        component: Benefit
    },
    {
        path: "/cookiepolicy",
        name: "cookiepolicy",
        component: CookiePolicy
    },
    {
        path: "/reconsent",
        name: "reconsent",
        component: Reconsent
    },
    {
        path: "/allbeverage",
        name: "allbeverage",
        component: AllBeverage,
        props: true
    },
    {
        path: "/packagedetail",
        name: "packagedetail",
        component: PackageDetail,
        props: true
    },
    {
        path: "/subscriptiondetail/:campaignId",
        name: "subscriptiondetail",
        component: SubscriptionDetail
    },
    {
        path: "/subscriptionForm",
        name: "subscriptionform",
        component: SubscriptionForm,
        props: true
    },
    {
        path: "*",
        name: "notfound",
        component: Notfound
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes
});

export default router;
